import { RefObject, useEffect, useRef, useState } from 'react';

import { LINE_COUNTS_THRESHOLD } from 'src/utils/constants/ConsumptionPagesConstants';
import { getLinesCount } from 'src/utils/seoContent';

import {
  arrowHandlerWrap,
  hyperLinkContainer,
  moreAndLessIcon,
  seoDescriptionContainer,
  seoDescriptionContainerCollapse,
  showDescription
} from './SeoDescriptionStyle';

// Component props
type SeoDescriptionProps = {
  seoDescription: string;
  pageType?: string;
};

const useLinesCount = (element: RefObject<Element>) => {
  const [linesCount, setLinesCount] = useState(-1);
  useEffect(() => {
    if (element) setLinesCount(getLinesCount(element));
  }, [element]);
  return linesCount;
};

const SeoDescription = ({ seoDescription, pageType }: SeoDescriptionProps) => {
  const [showMoreDescription, setShowMoreDescription] = useState(false);

  const accoridanRef = useRef<HTMLDivElement>(null);

  const linesCount = useLinesCount(accoridanRef);

  const moreBtnClickHandler = () => {
    setShowMoreDescription((showMoreDescription) => !showMoreDescription);
  };

  return (
    <>
      {seoDescription ? (
        <div
          css={[
            seoDescriptionContainer(pageType as string),
            linesCount > LINE_COUNTS_THRESHOLD &&
              seoDescriptionContainerCollapse(showMoreDescription)
          ]}
          data-testid="seoDescriptionWrapper">
          <div css={showDescription} data-testid="seoDescription">
            <div css={arrowHandlerWrap} data-testid="seoDescriptionWrap">
              <div
                ref={accoridanRef}
                css={[hyperLinkContainer]}
                dangerouslySetInnerHTML={{ __html: seoDescription }}
                data-testid="seoDescriptionInnerHTML"
              />
            </div>
          </div>
          {linesCount > LINE_COUNTS_THRESHOLD ? (
            <div
              data-testid="seoDescriptionThreShould"
              onClick={moreBtnClickHandler}
              css={moreAndLessIcon(showMoreDescription, pageType as string)}
            />
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default SeoDescription;
